import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "/api/v1";
// console.log('API_BASE_URL:', API_BASE_URL);

export const getUserById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/doctors/${id}`);
    return response.data; // The doctor object
  } catch (error) {
    console.error("Error fetching doctor:", error);
    throw error;
  }
};

export const updateUser = async (id, userData) => {
  try {
    const accountId = localStorage.getItem("account_id");
    if (!accountId) throw new Error("Account ID not found in localStorage");

    const payload = { ...userData, account_id: Number(accountId) };

    const response = await axios.patch(`${API_BASE_URL}/user/${id}`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error.response?.data || { message: "Something went wrong" };
  }
};

export const updateFcmToken = async (userId, token) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/user/${userId}`,
      {
        userId: userId,
        fcmtoken: token,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating FCM token:", error);
    return error.response?.data || { success: false, message: "Network error" };
  }
};

export const updateDoctorPassword = async (doctorId, currentPassword, newPassword) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/doctor/${doctorId}/password`, null, {
      params: {
        current: currentPassword,
        new: newPassword
      }
    });
    return response.data; // { message: "Password updated successfully" }
  } catch (error) {
    // Handle error
    if (error.response) {
      // Server responded with a status other than 2xx
      return { error: error.response.data.error };
    } else {
      return { error: error.message };
    }
  }
};



